objectFitImages();
(function($) {
    $( document ).ready(function() {


        /* Cards FB-Twitter - Page RA */
        function changeMetaContent(metaName, newMetaContent) {
            $("meta").each(function() {
                if($(this).attr("name") == metaName) {
                    $(this).attr("content" , newMetaContent);
                };
            });
        }

        jQuery('#bel-activity-2016 a.pop').click(function(e) {
            e.preventDefault();
            $("meta[property='og\\:image']").attr("content",$(this).data('tablet'));
            changeMetaContent("twitter:image", $(this).data('tablet'));
        });

        // IE9 - Fix placeholders
        $('[placeholder]').focus(function() {
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
                input.removeClass('placeholder');
            }
        }).blur(function() {
            var input = $(this);
            if (input.val() == '' || input.val() == input.attr('placeholder')) {
                input.addClass('placeholder');
                input.val(input.attr('placeholder'));
            }
        }).blur();

        /* sharing */
        function setShareLinks() {
            // bind share links
            var shareUrl = window.location.href;
            var shareTitle = jQuery(document).attr('title');
            var shareText = jQuery("meta[name=description]").attr('content');
            var shareImage = jQuery('meta[property="og:image"]').attr('content');


            jQuery('a[data-share="twitter"]').click(function(e){
                e.preventDefault();
                var twitterShareText = shareText;
                if(twitterShareText.length > 117) {
                    twitterShareText = twitterShareText.substring(0, 114); // -3 characters for "..."
                    var lastWordIndex = twitterShareText.lastIndexOf(" ");
                    twitterShareText = twitterShareText.substring(0, lastWordIndex);
                    twitterShareText += '...';
                }
                twitterShareText += ' #Bel';
                window.open('http://twitter.com/share?url=' + shareUrl + '&text=' + shareTitle + '&hashtags=Bel', 'twitterwindow', 'height=450, width=550, top='+(jQuery(window).height()/2 - 225) +', left='+jQuery(window).width()/2 +', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            });
            jQuery('a[data-share="facebook"]').click(function(e){
                e.preventDefault();

                if('[data-image]') {
                    shareImage = $(this).data('image');
                }

                window.open('https://www.facebook.com/sharer.php?t=' + shareText + '&p[images][0]=' + shareImage + '&u=' + shareUrl, 'facebookwindow', 'height=360, width=500, top='+(jQuery(window).height()/2 - 180) +', left='+jQuery(window).width()/2 +', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            });
            jQuery('a[data-share="mail"]').click(function(e){
                e.preventDefault();
                window.location.href = 'mailto:?subject='+shareTitle+'&body=Bonjour, %0D%0A %0D%0A Cet article pourrait vous intéresser : ' + shareUrl;
                // window.open("mailto:"'&subject='+shareTitle+'&body=Bonjour, Cet article pourrait vous intéresser : '+shareUrl);
            });

            jQuery('a[data-share="linkedin"]').click(function(e){
                e.preventDefault();

                if('[data-image]') {
                    shareImage = $(this).data('image');
                }

                window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + shareUrl + '&title=' + shareTitle + '&summary=' + shareText + '&submitted-image-url=' + shareImage, 'linkedinwindow', 'height=360, width=500, top='+(jQuery(window).height()/2 - 180) +', left='+jQuery(window).width()/2 +', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            });
        }
        setShareLinks();

        $("#reclamation").change(function(){
            if($(this).val() == "112"){
                $(".reclamation").css("display" , "block");
                $('.Produit').css("display" , "none");

                $("#reclam-brand").change(function(){

                    //obj.vachekiri[2].gamme
                    $("#variete").html("<option value=''>---</option>");
                    if($(this).val() == "A Vaca que ri"){
                        for(var i=0;i<obj.avacaqueri.length;i++){
                            $("#variete").append('<option value="'+obj.avacaqueri[i].gamme+'">'+obj.avacaqueri[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Apéricube"){
                        for(var i=0;i<obj.apericube.length;i++){
                            $("#variete").append('<option value="'+obj.apericube[i].gamme+'">'+obj.apericube[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Babybel"){
                        for(var i=0;i<obj.babybel.length;i++){
                            $("#variete").append('<option value="'+obj.babybel[i].gamme+'">'+obj.babybel[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Bonbel"){
                        for(var i=0;i<obj.bonbel.length;i++){
                            $("#variete").append('<option value="'+obj.bonbel[i].gamme+'">'+obj.bonbel[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Boursin"){
                        for(var i=0;i<obj.boursin.length;i++){
                            $("#variete").append('<option value="'+obj.boursin[i].gamme+'">'+obj.boursin[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Hard Discount"){
                        for(var i=0;i<obj.harddiscount.length;i++){
                            $("#variete").append('<option value="'+obj.harddiscount[i].gamme+'">'+obj.harddiscount[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Kiri"){
                        for(var i=0;i<obj.kiri.length;i++){
                            $("#variete").append('<option value="'+obj.kiri[i].gamme+'">'+obj.kiri[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "La vache qui rit"){
                        for(var i=0;i<obj.lavachequirit.length;i++){
                            $("#variete").append('<option value="'+obj.lavachequirit[i].gamme+'">'+obj.lavachequirit[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Leerdammer"){
                        for(var i=0;i<obj.leerdammer.length;i++){
                            $("#variete").append('<option value="'+obj.leerdammer[i].gamme+'">'+obj.leerdammer[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Limiano"){
                        for(var i=0;i<obj.limiano.length;i++){
                            $("#variete").append('<option value="'+obj.limiano[i].gamme+'">'+obj.limiano[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Loreto"){
                        for(var i=0;i<obj.loreto.length;i++){
                            $("#variete").append('<option value="'+obj.loreto[i].gamme+'">'+obj.loreto[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Maredsous"){
                        for(var i=0;i<obj.maredsous.length;i++){
                            $("#variete").append('<option value="'+obj.maredsous[i].gamme+'">'+obj.maredsous[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Mini Babybel"){
                        for(var i=0;i<obj.minibabybel.length;i++){
                            $("#variete").append('<option value="'+obj.minibabybel[i].gamme+'">'+obj.minibabybel[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Pastor"){
                        for(var i=0;i<obj.pastor.length;i++){
                            $("#variete").append('<option value="'+obj.pastor[i].gamme+'">'+obj.pastor[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Port Salut"){
                        for(var i=0;i<obj.portsalut.length;i++){
                            $("#variete").append('<option value="'+obj.portsalut[i].gamme+'">'+obj.portsalut[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Six au choix"){
                        for(var i=0;i<obj.sixauchoix.length;i++){
                            $("#variete").append('<option value="'+obj.sixauchoix[i].gamme+'">'+obj.sixauchoix[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Sylphide"){
                        for(var i=0;i<obj.sylphide.length;i++){
                            $("#variete").append('<option value="'+obj.sylphide[i].gamme+'">'+obj.sylphide[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Syrtos"){
                        for(var i=0;i<obj.syrtos.length;i++){
                            $("#variete").append('<option value="'+obj.syrtos[i].gamme+'">'+obj.syrtos[i].gamme+'</option>');
                        }
                    }
                    else if($(this).val() == "Barra"){
                        for(var i=0;i<obj.barra.length;i++){
                            $("#variete").append('<option value="'+obj.barra[i].gamme+'">'+obj.barra[i].gamme+'</option>');
                        }
                    }
                });
            }
            else{
                $(".reclamation").css("display" , "none");
                $('.Produit').css("display" , "block");
            }
        })

        /* recaptcha */
        var tag = document.createElement('script'),
            firstScriptTag = document.getElementsByTagName('script')[0],
            lang = document.documentElement.lang;
        if(tag && firstScriptTag) {
            tag.src = "https://www.google.com/recaptcha/api.js?hl="+lang+"";
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }


        /* brands */

        $('form .item-row input').focus(function() {
            if(!$(this).val()) {
                $(this).closest('.item-row').find('.item-placeholder').addClass("inactive");
            }
        }).blur(function() {
            if(!$(this).val()) {
                $(this).closest('.item-row').find('.item-placeholder').removeClass("inactive");
            }
        })

        HomeVideo.init();
        Grid.init();
        BusinessReport.init();
        Survey.init();
        pageTabs();
        SVGCustom.init();
        AccordionBlock.init();

        CustomSelect.init('.select-site-groups');
        $('.select-site-groups').on( "c-select:change", function( event, url ) {
            if (url) { // require a URL
                window.open(url, '_blank');
            }
        });

        $('.search-form__field').on('click', function () {
            console.log('search field click')
            return false;
        })
        HomeVideoPopin.init();
    });

})(jQuery);